'use client';
import { EmailIcon, FacebookIcon, FooterIcon, InstaIcon, Logo, PhoneIcon, TwitterIcon, WhatsappIcon } from "@/assets/icons";
import { useRouter } from "next/navigation";
import { JSX } from "react";
interface ContactItem {
  icon: JSX.Element;
  title: string;
  href: string;
}
export const Footer = () => {
  const router = useRouter();
  const usefulLinks = [
    { title: 'Home', href: '/' },
    { title: 'About Us', href: '/about' },
    { title: 'Contact Us', href: '/contact-us' },
  ];
  const directLinks = [
    { title: 'International Tours', href: '/international-tour' },
    { title: 'Domestic Tours', href: '/domestic-tour' },
    { title: 'Pilgrimage Tours', href: '/pilgrimage-tour' },
    { title: 'Flight Tickets', href: '/flight-booking' },
    { title: 'Hotel Booking', href: '/hotel-booking' },
  ];
  const contact: ContactItem[] = [
    {
      icon: <EmailIcon />,
      title: "Info@mstourism.co.in",
      href: "mailto:Info@mstourism.co.in",
    },
    {
      icon: <PhoneIcon />,
      title: "+91 99786 04488",
      href: "tel:+91 99786 04488",
    },
  ];
  const socialIcons = [
    { icon: <InstaIcon />, href: "https://www.instagram.com/ms_tourism1/" },
    {
      icon: <WhatsappIcon />, href: "https://wa.me/919978604488?text=hello"
    },
    { icon: <FacebookIcon />, href: "https://www.facebook.com/mstoosdfsdf/" },
    { icon: <TwitterIcon />, href: "https://www.instagram.com/ms_tourism1/" },
  ];
  return (
    <div className="bg-[#3C51A00D]  pt-16 px-4 md:px-20 w-full">
      <div className="flex justify-between md:flex-wrap gap-5 md:flex-row flex-col">
        {/* Logo and Description */}
        <div className="col-span-1">
          <Logo />
          <p className="max-w-[20rem] pt-3">
            Explore the world with us – your trusted travel partner for unforgettable journeys and cherished memories.
          </p>
        </div>
        {/* Useful Links */}
        <div>
          <h4 className="font-bold text-dark-gray mb-3">Useful Links</h4>
          <ul>
            {usefulLinks.map((link, idx) => (
              <li key={idx} className="mb-1 text-dark-gray text-base cursor-pointer font-semibold">
                <a onClick={() => router.push(link.href)}>{link.title}</a>
              </li>
            ))}
          </ul>
        </div>
        {/* Direct Links */}
        <div>
          <h4 className="font-bold text-dark-gray mb-3">Direct Links</h4>
          <ul>
            {directLinks.map((link, idx) => (
              <li key={idx} className="mb-1 text-dark-gray text-base cursor-pointer font-semibold">
                <a onClick={() => router.push(link.href)}>{link.title}</a>
              </li>
            ))}
          </ul>
        </div>
        {/* Contact Us */}
        <div>
          <h4 className="font-bold text-dark-gray mb-3">Contact Us</h4>
          <div className="flex gap-1 flex-col">
            {contact.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="flex items-center gap-2 text-dark-gray hover:text-[#161D3A] transition"
                aria-label={item.title}
              >
                {item.icon}
                <p className="font-semibold">{item.title}</p>
              </a>
            ))}
          </div>
        </div>
        {/* Follow Us */}
        <div>
          <h4 className="font-bold text-dark-gray mb-3">Follow Us</h4>
          <div className="flex gap-3 text-xl">
            {socialIcons.map(({ icon, href }, idx) => (
              <a key={idx} href={href} target="_blank"
                rel="noopener noreferrer" className="text-dark-gray text-base">
                <div className=" w-11 h-11 flex justify-center items-center" style={{ border: "1px solid", borderRadius: "100px", }}>
                  {icon}
                </div>
              </a>
            ))}
          </div>
        </div>
        <div>
          <FooterIcon />
        </div>
      </div>
    </div>
  );
};
